// extracted by mini-css-extract-plugin
module.exports = {"layout":"ApplicationDetailsConfigurationPage_layout__1Ou6E"};